import { useServicesQuery } from '@/services/api';
import type { ServicesApiGetEnvHealthQueryParams } from '@/services/api/services-api';
import { WORKSPACE_HEALTH_REFETCH_INTERVAL } from '../constants';

export function useEnvHealth(workspaceId: number, simulate: ServicesApiGetEnvHealthQueryParams['simulate']) {
  return useServicesQuery(
    'getEnvHealth',
    { params: { environment_id: workspaceId }, query: { simulate } },
    {
      refetchInterval: WORKSPACE_HEALTH_REFETCH_INTERVAL,
      enabled: workspaceId > 0,
      // false because we are tabbing between tabs, so we don't want to refetch
      refetchOnMount: false,
    },
  );
}
